import { capitalizeFirstLetter } from './capitalize-first-letter';

export const toPascalCase = (value: string): string => {
  const words = value.split(' ').map(item => capitalizeFirstLetter(item));
  return words.join('');
};
